import {
	Box,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	IconButton,
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';

const PipelineFilters = ({ filterOptions, currentFilters, onFilterChange }) => {
	const handleFilterChange = (field, value) => {
		onFilterChange({
			...currentFilters,
			[field]: value,
		});
	};

	const clearFilters = () => {
		onFilterChange({
			owner_id: '',
			fund_id: '',
			industry: '',
		});
	};

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: 1,
			}}
		>
			<FilterListIcon color='action' fontSize='small' />

			{/* Owner Filter */}
			<FormControl size='small' sx={{ minWidth: 120 }}>
				<InputLabel id='owner-filter-label'>Owner</InputLabel>
				<Select
					labelId='owner-filter-label'
					value={currentFilters.owner_id}
					label='Owner'
					onChange={(e) => handleFilterChange('owner_id', e.target.value)}
				>
					<MenuItem value=''>
						<em>All Owners</em>
					</MenuItem>
					{filterOptions?.owners?.map((owner) => (
						<MenuItem key={owner.id} value={owner.id}>
							{owner.name}
						</MenuItem>
					))}
				</Select>
			</FormControl>

			{/* Fund Filter */}
			<FormControl size='small' sx={{ minWidth: 120 }}>
				<InputLabel id='fund-filter-label'>Fund</InputLabel>
				<Select
					labelId='fund-filter-label'
					value={currentFilters.fund_id}
					label='Fund'
					onChange={(e) => handleFilterChange('fund_id', e.target.value)}
				>
					<MenuItem value=''>
						<em>All Funds</em>
					</MenuItem>
					{filterOptions?.funds?.map((fund) => (
						<MenuItem key={fund.id} value={fund.id}>
							{fund.name}
						</MenuItem>
					))}
				</Select>
			</FormControl>

			{/* Industry Filter */}
			<FormControl size='small' sx={{ minWidth: 120 }}>
				<InputLabel id='industry-filter-label'>Industry</InputLabel>
				<Select
					labelId='industry-filter-label'
					value={currentFilters.industry}
					label='Industry'
					onChange={(e) => handleFilterChange('industry', e.target.value)}
				>
					<MenuItem value=''>
						<em>All Industries</em>
					</MenuItem>
					{filterOptions?.industries?.map((industry) => (
						<MenuItem key={industry} value={industry}>
							{industry}
						</MenuItem>
					))}
				</Select>
			</FormControl>

			{/* Clear Filters Button */}
			{(currentFilters.owner_id ||
				currentFilters.fund_id ||
				currentFilters.industry) && (
				<IconButton size='small' onClick={clearFilters} color='default'>
					<ClearIcon fontSize='small' />
				</IconButton>
			)}
		</Box>
	);
};

export default PipelineFilters;
